import Format from 'root/apps/helpers/format';

import Decimal from '../data/base/Decimal';

const minimumTransactionAmountByCurrency = {
  USD: 0.5,
  CAD: 0.5,
  GBP: 0.3,
};

type CurrencyWithRequiredMinAmount = keyof typeof minimumTransactionAmountByCurrency;

/**
 * Type predicate to check if the currency is of type CurrencyWithRequiredMinAmount
 */
function doesCurrencyHaveRequiredMin(currency: string): currency is CurrencyWithRequiredMinAmount {
  return Object.keys(minimumTransactionAmountByCurrency).includes(currency);
}

/**
 * Check if the amount is less than the minimum amount required for the currency
 *
 * Only for Lightspeed Payments gateway
 *
 * If invalid, throw an error whose message can be bubbled up to the user
 *
 * @param amount
 * @param currency
 * @param isLspay
 */
export function validateMinAmount(amount: Decimal, currency: string, isLspay: boolean) {
  if (!isLspay || !doesCurrencyHaveRequiredMin(currency)) {
    return;
  }

  const minimumAmount = minimumTransactionAmountByCurrency[currency];

  if (amount.abs().toNumber() < minimumAmount) {
    throw new Error(
      `The minimum for processing a card transaction is ${Format.toMoney(
        minimumAmount,
        currency
      )}. Please update the amount and try again.`
    );
  }
}
